// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1kwK1","alert":"SettungsInbox_alert__3t92t"};